import { createApi } from '@reduxjs/toolkit/query/react';
import {
  Article,
  ArticleDetailsRequest,
  CmsConfigs,
  Helps,
  LocaleParams,
  PromoBanner,
  OnlyContentModel,
  ContentHrefTargetModel,
} from '../../models';
import { cmsFetchBaseQuery, mlkOnQueryStarted } from '../utils';

export const cmsApi = createApi({
  reducerPath: 'cmsApi',
  baseQuery: cmsFetchBaseQuery,
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    getCmsConfigs: builder.query<CmsConfigs, undefined>({
      onQueryStarted: mlkOnQueryStarted,
      query: () => `/config`,
    }),
    getCmsHelps: builder.query<Helps, LocaleParams>({
      onQueryStarted: mlkOnQueryStarted,
      query: ({ locale }) => ({
        url: `/help`,
        params: {
          locale,
        },
      }),
    }),
    getCmsArticles: builder.query<Article[], LocaleParams>({
      onQueryStarted: mlkOnQueryStarted,
      query: ({ locale }) => ({
        url: `/articles`,
        params: {
          locale,
        },
      }),
    }),
    getCmsArticle: builder.query<Article, ArticleDetailsRequest>({
      onQueryStarted: mlkOnQueryStarted,
      query: ({ locale, newsId }) => ({
        url: `/articles/${newsId}`,
        params: {
          locale,
        },
      }),
    }),
    getCmsBanners: builder.query<PromoBanner[], LocaleParams>({
      onQueryStarted: mlkOnQueryStarted,
      query: ({ locale }) => ({
        url: `/promotional-banners`,
        params: {
          locale,
        },
      }),
    }),
    getTermsAndConditions: builder.query<ContentHrefTargetModel, LocaleParams>({
      onQueryStarted: mlkOnQueryStarted,
      query: ({ locale }) => ({
        url: `/terms-and-conditions`,
        params: {
          locale,
        },
      }),
    }),
    getPrivacyPolicy: builder.query<ContentHrefTargetModel, LocaleParams>({
      onQueryStarted: mlkOnQueryStarted,
      query: ({ locale }) => ({
        url: `/privacy`,
        params: {
          locale,
        },
      }),
    }),
    getBenefit: builder.query<OnlyContentModel, LocaleParams>({
      onQueryStarted: mlkOnQueryStarted,
      query: ({ locale }) => ({
        url: `/benefit`,
        params: {
          locale,
        },
      }),
    }),
  }),
});
